/**
 * Bundle Collection Builder
 * Handles product selection and cart management for bundle collections
 */

let MONEY_FORMAT = 'Rs. {{amount}}';
let bundleState = {
  products: [],
  minProducts: 3,
  discount3: 10,
  discount5: 20
};

/**
 * Initialize bundle with settings from Liquid
 */
function initBundle(settings) {
  MONEY_FORMAT = settings.moneyFormat || 'Rs. {{amount}}';
  bundleState.minProducts = settings.minProducts || 3;
  bundleState.discount3 = settings.discount3 || 10;
  bundleState.discount5 = settings.discount5 || 20;
  
  console.log('Bundle initialized with settings:', {
    minProducts: bundleState.minProducts,
    discount3: bundleState.discount3,
    discount5: bundleState.discount5,
    moneyFormat: MONEY_FORMAT
  });
  
  updateBundleUI();
}

/**
 * Toggle product selection in bundle
 */
function toggleBundleProduct(button) {
  const card = button.closest('.bundle-product-card');
  const productId = card.dataset.productId;
  const variantId = card.dataset.variantId;
  const price = parseFloat(card.dataset.price);
  const productTitle = card.dataset.productTitle;
  const counter = card.querySelector('.bundle-product-counter');
  const addText = button.querySelector('.btn-text-add');
  const removeText = button.querySelector('.btn-text-remove');

  const existingIndex = bundleState.products.findIndex(p => p.variantId === variantId);

  if (existingIndex > -1) {
    // Remove product
    bundleState.products.splice(existingIndex, 1);
    card.classList.remove('selected');
    button.classList.remove('added');
    addText.style.display = 'inline';
    removeText.style.display = 'none';
    counter.textContent = '1';
  } else {
    // Add product
    bundleState.products.push({
      productId,
      variantId,
      price,
      quantity: 1,
      title: productTitle
    });
    card.classList.add('selected');
    button.classList.add('added');
    addText.style.display = 'none';
    removeText.style.display = 'inline';
  }

  updateBundleUI();
}

/**
 * Update the sticky bar UI with current bundle state
 */
function updateBundleUI() {
  const itemCount = bundleState.products.length;
  const stickyBar = document.getElementById('bundleStickyBar');
  const checkoutBtn = document.getElementById('bundleCheckoutBtn');
  const originalPriceEl = document.getElementById('bundleOriginalPrice');
  const savingsEl = document.getElementById('bundleSavings');
  const finalPriceEl = document.getElementById('bundleFinalPrice');
  const itemsCountEl = document.getElementById('bundleItemsCount');
  
  if (!stickyBar) return; // Exit if elements don't exist yet
  
  if (itemCount > 0) {
    stickyBar.classList.add('active');
  } else {
    stickyBar.classList.remove('active');
  }

  // Calculate totals
  let originalTotal = 0;
  bundleState.products.forEach(p => {
    originalTotal += p.price * p.quantity;
  });

  // Calculate discount
  let discount = 0;
  if (itemCount >= 5) {
    discount = bundleState.discount5;
  } else if (itemCount >= 3) {
    discount = bundleState.discount3;
  }

  const discountAmount = originalTotal * (discount / 100);
  const finalTotal = originalTotal - discountAmount;

  // Update item count
  itemsCountEl.textContent = `${itemCount} item${itemCount !== 1 ? 's' : ''} selected`;
  
  // Show/hide original price and savings based on discount
  if (discount > 0 && discountAmount > 0) {
    originalPriceEl.textContent = formatMoney(originalTotal);
    originalPriceEl.style.display = 'inline';
    savingsEl.textContent = `Save ${formatMoney(discountAmount)} (${discount}%)`;
    savingsEl.style.display = 'inline-block';
  } else {
    originalPriceEl.style.display = 'none';
    savingsEl.style.display = 'none';
  }
  
  // Always show final price
  finalPriceEl.textContent = formatMoney(finalTotal);

  // Update button state
  checkoutBtn.disabled = itemCount < bundleState.minProducts;
  
  if (itemCount < bundleState.minProducts) {
    checkoutBtn.textContent = `Select ${bundleState.minProducts - itemCount} more item${bundleState.minProducts - itemCount > 1 ? 's' : ''}`;
  } else {
    checkoutBtn.textContent = 'Proceed to Checkout';
  }

  // Debug log
  console.log('Bundle State:', {
    itemCount,
    originalTotal: formatMoney(originalTotal),
    discount: discount + '%',
    discountAmount: formatMoney(discountAmount),
    finalTotal: formatMoney(finalTotal),
    products: bundleState.products
  });
}

/**
 * Format price in cents to currency string
 */
function formatMoney(cents) {
  if (typeof cents === 'undefined' || cents === null || isNaN(cents)) {
    cents = 0;
  }
  
  // Try to use Shopify's built-in formatMoney function if available
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, MONEY_FORMAT);
  }
  
  // Fallback: manual formatting
  const amount = (cents / 100).toFixed(2);
  const amountNoCents = Math.floor(cents / 100).toString();
  const amountWithComma = amount.replace('.', ',');
  
  // Replace all possible placeholders
  let formatted = MONEY_FORMAT
    .replace(/\{\{\s*amount\s*\}\}/g, amount)
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoCents)
    .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ' '))
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoCents.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
    .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amount.replace(/\B(?=(\d{3})+(?!\d))/g, "'"));
  
  return formatted;
}

/**
 * Add all selected products to cart and redirect
 */
async function proceedToCheckout() {
  if (bundleState.products.length < bundleState.minProducts) {
    alert(`Please select at least ${bundleState.minProducts} products`);
    return;
  }

  const checkoutBtn = document.getElementById('bundleCheckoutBtn');
  const originalText = checkoutBtn.textContent;
  checkoutBtn.disabled = true;
  checkoutBtn.textContent = 'Adding to cart...';

  try {
    const formData = {
      items: bundleState.products.map(p => ({
        id: p.variantId,
        quantity: p.quantity
      }))
    };

    console.log('Sending to cart:', formData);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });

    if (response.ok) {
      const result = await response.json();
      console.log('Cart response:', result);
      window.location.href = '/cart';
    } else {
      const errorData = await response.json();
      throw new Error(errorData.description || 'Failed to add to cart');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Failed to add items to cart. Please try again.');
    checkoutBtn.disabled = false;
    checkoutBtn.textContent = originalText;
  }
}

// Make functions available globally
window.initBundle = initBundle;
window.toggleBundleProduct = toggleBundleProduct;
window.proceedToCheckout = proceedToCheckout;